import { z } from 'zod'
import { oc } from '@orpc/contract'
import { CPG_MEASURE_KIND_VALUES, cpgMeasureSchema } from './cpg-registry.contract'

/**
 * Measure registry endpoints (PD-1711, docs/cpg/CPG_ADMIN.md). Like families the registry is
 * one screenful, so the list is unpaged and flat — the Measures view groups it by family
 * using the families tree it already has. Every status is returned; callers filter.
 */
export const listCpgMeasures = oc
  .route({ method: 'GET', path: '/v2/cpg/measures' })
  .input(z.object({}).optional())
  .output(z.object({ data: z.array(cpgMeasureSchema) }))

/**
 * Admin-created measures are born `active` with `origin = 'manual'`; an accepted proposal
 * cluster creates `origin = 'clustered'` ones (PD-1716).
 * The family must be active (CONFLICT otherwise); a duplicate slug is CONFLICT too.
 */
export const createCpgMeasure = oc
  .route({ method: 'POST', path: '/v2/cpg/measures' })
  .input(
    z.object({
      familyId: z.number().int().positive(),
      /** kebab-case, the agent-facing identity — immutable once created. */
      slug: z
        .string()
        .regex(/^[a-z0-9]+(-[a-z0-9]+)*$/, 'slug must be kebab-case (a-z, 0-9, dashes)'),
      kind: z.enum(CPG_MEASURE_KIND_VALUES),
      label: z.string().min(1),
      definition: z.string().min(1),
      gradingRule: z.string().min(1),
    }),
  )
  .output(z.object({ data: cpgMeasureSchema }))

/**
 * Partial edit; slug, kind and family are immutable. `status` is retire / reactivate.
 */
export const updateCpgMeasure = oc
  .route({ method: 'PATCH', path: '/v2/cpg/measures/{id}' })
  .input(
    z.object({
      id: z.coerce.number().int().positive(),
      label: z.string().min(1).optional(),
      definition: z.string().min(1).optional(),
      gradingRule: z.string().min(1).optional(),
      status: z.enum(['active', 'retired']).optional(),
    }),
  )
  .output(z.object({ data: cpgMeasureSchema }))
